import React, { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { Loading } from "@/auth/Loading";
import { useAuth } from "@/auth/useAuth";
import { vb360Access } from "@/features/vb360/access/vb360-access";
import { useVb360Context } from "@/features/vb360/hooks/use-vb360-context";
import { Vb360StatePage } from "@/features/vb360/pages/Vb360StatePage";

export const Vb360Route: React.FC<{ children: ReactNode }> = ({ children }) => {
    const { state } = useAuth();
    const vb360 = useVb360Context();

    if (vb360Access.featureEnabled() === false) return <Navigate to="/command-center" replace />;
    if (vb360.status === "forbidden") return <Vb360StatePage kind="forbidden" />;
    if (vb360.status === "unavailable") return <Vb360StatePage kind="unavailable" />;
    if (vb360.status !== "ready") return <Loading />;

    return <React.Fragment key={state.user?.id ?? ""}>{children}</React.Fragment>;
};
